import { MimaButton, MimaText, Modal, MimaTextArea } from "../../components";

import { Formik } from "formik";
import React from "react";

const ApprovePayout = ({ closeModal, validationSchema, loading, onSubmit }) => {
  return (
    <Modal closeModal={closeModal}>
      <MimaText variant="subtitle" align="center" mb={4}>
        Approve Payout
      </MimaText>

      <Formik
        initialValues={{
          tag: "",
          comment: "",
        }}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({
          handleSubmit,
          setFieldValue,
          handleBlur,
          handleChange,
          values,
          errors,
          touched,
        }) => (
          <>
            <MimaTextArea
              type="textarea"
              labelTitle="Comment"
              placeholder="Enter Comment"
              name="comment"
              mb={2}
              variant="message"
              error={errors.comment}
              touched={touched.comment}
              value={values.comment}
              onChange={handleChange}
              onBlur={handleBlur}
            />
            <MimaButton
              title="Submit"
              onClick={handleSubmit}
              type="submit"
              loading={loading}
              mt={2}
              width={38}
            />
          </>
        )}
      </Formik>
    </Modal>
  );
};

export default ApprovePayout;
